import { useCallback, useState } from "react";
import useInput from "skin/entry/hook/input2";
import company from "skin/entry/query/company";

export default function useInnLookup() {
    const [cmp, setCmp] = useState(null);
    const [inn, , onChangeInn, errInn, setErrInn] = useInput('');
    const [wait, setWait] = useState(false);
    const reset = useCallback(() => setCmp(null), []);

    const findCompany = useCallback(() => {
        setWait(true);
        company(inn)
            .then(r => {
                if (!r) return Promise.reject('Не удалось найти компанию.');
                setCmp(r);
            })
            .catch(err => {
				const msg = err?.custom ? err.message : err.toString();
				setErrInn(msg);
			})
            .finally(() => setWait(false));
    }, [inn]);

    return {
        value: inn, onChange: onChangeInn,
        err: errInn, setErr: setErrInn, wait,
        reset, cmp, findCompany
    };
}